import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'
// import { app } from '@/main'

const communityNoticesModule = {
  state: {
    // 社區公告類別列表
    communityCategories: [],
    // 社區公告列表
    communityNotices: [],
    // 社區公告詳細資訊
    communityNoticeDetail: []
  },
  actions: {
    // 取得公告類別清單
    async GET_COMMUNITY_CATEGORIES({ commit }, payload) {
      // console.log('GET_COMMUNITY_CATEGORIES payload: ', payload)
      try {
        const res = await baseFetch(
          API.getCommunityCategories.url,
          API.getCommunityCategories.method,
          payload
        )
        // console.log('res: ', res)
        if (!res.isError && res.data) {
          commit('SET_COMMUNITY_CATEGORIES', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 取得社區列表
    async GET_COMMUNITY_NOTICES({ commit }, payload) {
      // console.log('GET_COMMUNITY_NOTICES payload: ', payload)
      try {
        const communityId = payload.communityId
        const res = await baseFetch(
          API.getCommunityNotices.url(communityId),
          API.getCommunityNotices.method,
          payload.params
        )
        // console.log('res: ', res)
        if (!res.isError && res.data) {
          commit('SET_COMMUNITY_NOTICES', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 取得公告詳細資訊
    async GET_COMMUNITY_NOTICE_DETAIL({ commit }, payload) {
      // console.log('GET_COMMUNITY_NOTICE_DETAIL payload: ', payload)
      try {
        const communityNoticeId = payload.communityNoticeId
        const res = await baseFetch(
          API.getCommunityNoticesById.url(communityNoticeId),
          API.getCommunityNoticesById.method
        )
        // console.log('res: ', res)
        if (!res.isError && res.data) {
          commit('SET_COMMUNITY_NOTICE_DETAIL', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 新增社區公告
    async POST_COMMUNITY_NOTICE({ dispatch }, payload) {
      // console.log('POST_COMMUNITY_NOTICE payload: ', payload)
      try {
        const { params, applySchedule } = payload
        const res = await baseFetch(
          API.postCommunityNotices.url,
          API.postCommunityNotices.method,
          params
        )
        // console.log('新增社區公告 res: ', res)
        if (!res.isError && res.data && !applySchedule) return res
        if (!res.isError && res.data && applySchedule) {
          const communityNoticeId = res.data.data.communityNoticeId
          const scheduleRes = await dispatch(
            'APPLY_COMMUNITY_NOTICE_SCHEDULE',
            { communityNoticeId }
          )
          // console.log('scheduleRes: ', scheduleRes)
          return scheduleRes
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 編輯社區公告
    async PUT_COMMUNITY_NOTICE({ dispatch }, payload) {
      // console.log('PUT_COMMUNITY_NOTICE payload: ', payload)
      try {
        const { communityNoticeId, params, applySchedule } = payload
        const res = await baseFetch(
          API.putCommunityNotices.url(communityNoticeId),
          API.putCommunityNotices.method,
          params
        )
        if (!res.isError && res.data && !applySchedule) return res
        // TODO: 目前編輯頁排程需要先儲存後做排程動作再打開
        if (!res.isError && res.data && applySchedule) {
          const dispatchApi =
            applySchedule === 'remove'
              ? 'REMOVE_COMMUNITY_NOTICE_SCHEDULE'
              : 'APPLY_COMMUNITY_NOTICE_SCHEDULE'
          const communityNoticeId = res.data.data.communityNoticeId
          const scheduleRes = await dispatch(dispatchApi, { communityNoticeId })
          // console.log('scheduleRes: ', scheduleRes)
          return scheduleRes
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 刪除社區公告
    async DELETE_COMMUNITY_NOTICE(_, payload) {
      // console.log('DELETE_COMMUNITY_NOTICE payload: ', payload)
      try {
        const communityNoticeId = payload.communityNoticeId
        const res = await baseFetch(
          API.deleteCommunityNoticeId.url(communityNoticeId),
          API.deleteCommunityNoticeId.method
        )
        // console.log('res: ', res)
        if (!res.isError && res.data) {
          return res
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 社區公告加入排程
    async APPLY_COMMUNITY_NOTICE_SCHEDULE(_, payload) {
      // console.log('APPLY_COMMUNITY_NOTICE_SCHEDULE payload: ', payload)
      try {
        const communityNoticeId = payload.communityNoticeId
        const res = await baseFetch(
          API.postCommunityNoticesSchedule.url(communityNoticeId),
          API.postCommunityNoticesSchedule.method
        )
        // console.log('res: ', res)
        return res
      } catch (error) {
        console.error('error', error)
      }
    },
    // 撤除社區公告排程
    async REMOVE_COMMUNITY_NOTICE_SCHEDULE(_, payload) {
      // console.log('REMOVE_COMMUNITY_NOTICE_SCHEDULE payload: ', payload)
      try {
        const communityNoticeId = payload.communityNoticeId
        const res = await baseFetch(
          API.deleteCommunityNoticesSchedule.url(communityNoticeId),
          API.deleteCommunityNoticesSchedule.method
        )
        // console.log('res: ', res)
        if (!res.isError && res.data) {
          return res
        }
      } catch (error) {
        console.error('error', error)
      }
    }
  },
  mutations: {
    // 儲存社區公告類別清單
    SET_COMMUNITY_CATEGORIES(state, payload) {
      state.communityCategories = payload
    },
    // 儲存社區公告列表
    SET_COMMUNITY_NOTICES(state, payload) {
      state.communityNotices = payload
    },
    // 儲存社區公告詳細資訊
    SET_COMMUNITY_NOTICE_DETAIL(state, payload) {
      state.communityNoticeDetail = payload
    }
  },
  getters: {
    getCommunityCategories: (state) => state.communityCategories,
    getCommunityNotices: (state) => state.communityNotices,
    getCommunityNoticeDetail: (state) => state.communityNoticeDetail
  },
  namespaced: true
}

export default communityNoticesModule
